import React from 'react';
import { Badge } from 'reactstrap';
import {Link} from "react-router-dom";

const CartHeader = ({ count }) => {
	const containerStyle = {
		position: 'relative',
		display: 'inline-block',
		marginRight: '10px',
	};

	const iconStyle = {
		fontSize: '1.7rem',
		verticalAlign: 'middle',
	};

	const badgeStyle = {
		position: 'absolute',
		top: '15%',
		left: '95%',
		transform: 'translate(-50%, -50%)',
		minWidth: '10px',
		height: '10px',
		borderRadius: '50%',
		display: 'flex',
		backgroundColor: 'red',
	};

	return (
		<Link to={{pathname: "/checkout"}}>
			<div style={containerStyle}>
				<i className="fa fa-shopping-cart header-cart-icon" style={iconStyle} aria-hidden="true"></i>
				{count > 0 && (
					<Badge color="primary" style={badgeStyle}></Badge>
				)}
			</div>
		</Link>
	);
};

export default CartHeader;
